module.exports = __webpack_public_path__ + "img/userA07.241c49fd.jpg";